import { sortBy, uniq } from 'lodash';

export default {
  getSolution: (state) => state.solution,
  solutionOwners: (state) => sortBy(uniq(state.solutions.map((q) => ({
    text: q.owner,
    value: q.ownerId,
  }))), 'text'),
};
